import { THEMES_PATH } from '@stores/actions/action_types'
import { getAppBridgeInstance, getCachedApp, getHost } from '@utils/appBridge'
import { getSessionTokenOrRedirect } from '@utils/shopifyAuthFailure'
import { pickInvoiceThemeIdFromCurrentThemes } from './pickInvoiceThemeId'

export const fetchInvoiceThemeId = async (): Promise<string | null> => {
  try {
    const host = getHost()
    const cachedApp = getCachedApp()
    const app = cachedApp ?? (host ? getAppBridgeInstance(host) : null)

    if (!app) {
      return null
    }

    const token = await getSessionTokenOrRedirect(app)
    const response = await fetch(`${THEMES_PATH}/current`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    if (!response.ok) {
      return null
    }

    const data = (await response.json()) as Parameters<typeof pickInvoiceThemeIdFromCurrentThemes>[0]
    return pickInvoiceThemeIdFromCurrentThemes(data)
  } catch (error) {
    console.warn('[virtual-tour] Failed to fetch invoice theme id', error)
    return null
  }
}
